import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import InternalLink from '../../InternalLink/InternalLink'
import { RestaurantConsumer } from '../../RestaurantProvider/RestaurantProvider'

import { MenuItemPrice } from './MenuItemPrice/MenuItemPrice'
import { MenuItemImage } from './MenuItemImage/MenuItemImage'

import './MenuItems.css'
import { imgInPreprod } from '../../../utils/img-url'

const MenuItems = ({ items }) => (
  <RestaurantConsumer>
    {({ getRestaurantPath }) => (
      <ul data-testid='menu-items' styleName='menuItems'>
        {items.map(({
          name,
          guid,
          price,
          outOfStock,
          description,
          imageUrl,
          calories,
          itemGroupGuid,
          usesFractionalQuantity,
          unitOfMeasure
        }) => {
          imageUrl = imgInPreprod(imageUrl)
          return (
            <li data-testid='menu-item' key={`${guid}${itemGroupGuid || ''}`} styleName={cx('menuItem', {outOfStock})} >
              <InternalLink data-testid='menu-item-link'
                eventData={[
                  ['ec', 'addProduct', { id: guid, name }],
                  ['ec', 'setAction', 'click']
                ]}
                styleName='menuItemLink'
                to={getRestaurantPath(`add/${guid}/${itemGroupGuid}`)}
              >
                <div data-testid='menu-item-content' styleName='content'>
                  <span data-testid='menu-item-name' styleName='name'>{name}</span>
                  <p data-testid='menu-item-description' styleName='description'>{description}</p>
                  {outOfStock && <span data-testid='menu-item-out-of-stock-label' styleName='outOfStockLabel'>–Out of stock–</span>}
                  {price > 0 && !outOfStock &&
                    <MenuItemPrice
                      price={price}
                      usesFractionalQuantity={usesFractionalQuantity}
                      unitOfMeasure={unitOfMeasure}
                    />
                  }
                  {calories > 0 &&
                    <span data-testid='menu-item-calories' styleName='calories'>
                      {calories} Cal
                    </span>
                  }
                </div>
                <MenuItemImage imageUrl={imageUrl} outOfStock={outOfStock} />
              </InternalLink>
            </li>
          )
        })}
      </ul>
    )}
  </RestaurantConsumer>
)

const MenuItemsShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  guid: PropTypes.string.isRequired,
  price: PropTypes.number
})

MenuItems.propTypes = {
  items: PropTypes.arrayOf(MenuItemsShape)
}

export default MenuItems
export { MenuItemsShape }
